import ObjetivoService from 'src/modules/objetivo/objetivoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'OBJETIVO_VIEW';

const objetivoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: objetivoViewActions.FIND_STARTED,
      });

      const record = await ObjetivoService.find(id);

      dispatch({
        type: objetivoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objetivoViewActions.FIND_ERROR,
      });

      getHistory().push('/objetivo');
    }
  },
};

export default objetivoViewActions;
